export default "__VITE_ASSET__54tNQB9V__"